import { compose, withHandlers } from 'recompose';
import PropTypes from 'prop-types';
import ReactDayPicker from 'react-day-picker';
import React from 'react';

import { nullFunc } from '../utils/helpers';
import WithToggle from '../hoc/WithToggle';
import Modal from './Modal';
import Icon, { GLYPHS } from './Icon';

const NavbarElement = ({ onPreviousClick, onNextClick }) => (
  <div className="DayPicker-NavBar">
    <button
      className="DayPicker-NavButton DayPicker-NavButton--next"
      type="button"
      onClick={() => onNextClick()}
    >
      <Icon glyph={GLYPHS.ARROW_CIRCLE_RIGHT} className="DayPicker-Icon" />
    </button>
    <button
      className="DayPicker-NavButton DayPicker-NavButton--prev"
      type="button"
      onClick={() => onPreviousClick()}
    >
      <Icon glyph={GLYPHS.ARROW_CIRCLE_LEFT} className="DayPicker-Icon" />
    </button>
  </div>
);
NavbarElement.propTypes = {
  onPreviousClick: PropTypes.func.isRequired,
  onNextClick: PropTypes.func.isRequired,
};

const DatePickerButton = ({
  selectedDay,
  onDayClick,
  on,
  off,
  toggled,
  disabledDays,
  daysOff,
  daysOn,
  weekdaysOff,
}) => (
  <div>
    <button
      className="c-btn c-btn--bare u-co-teal u-nudge-t3"
      type="button"
      onClick={on}
    >
      <Icon glyph={GLYPHS.CALENDAR} className="c-datepicker-icon" />
    </button>
    {toggled && (
      <Modal close={off}>
        <ReactDayPicker
          onDayClick={onDayClick}
          selectedDays={selectedDay}
          disabledDays={disabledDays}
          month={selectedDay}
          navbarElement={NavbarElement}
          modifiers={{ daysOff, daysOn, weekdaysOff: { daysOfWeek: weekdaysOff } }}
        />
      </Modal>
    )}
  </div>
);
DatePickerButton.propTypes = {
  on: PropTypes.func.isRequired,
  off: PropTypes.func.isRequired,
  toggled: PropTypes.bool.isRequired,
  onDayClick: PropTypes.func,
  selectedDay: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.instanceOf(Date),
  ]),
  disabledDays: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  daysOff: PropTypes.array, // eslint-disable-line react/forbid-prop-types
  daysOn: PropTypes.array, // eslint-disable-line react/forbid-prop-types
  weekdaysOff: PropTypes.array, // eslint-disable-line react/forbid-prop-types
};
DatePickerButton.defaultProps = {
  onDayClick: nullFunc,
  selectedDay: new Date(),
  disabledDays: null,
  daysOff: null,
  daysOn: null,
  weekdaysOff: null,
};

export default compose(
  WithToggle,
  withHandlers((initialProps) => {
    if (!initialProps.onDayClick) return null;
    return {
      onDayClick: props => (day, { disabled } = {}) => {
        if (disabled) return;
        props.onDayClick(day);
        props.off();
      },
    };
  })
)(DatePickerButton);



// WEBPACK FOOTER //
// ./src/app/components/DatePickerButton.jsx